import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import { axiosGet, axiosPost, axiosPut, axiosDelete } from "../../utils/common/axios";
import { 
   
} from "../actions";

export function* sendOtpToUserNumberEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`otp/send?userName=${action?.data?.payload}&messageId=1`));
    action.data?.callback?.success?.(data);
    // toast.success(data?.message || "Otp saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401){
      toast?.error("Invalid Email address or password.Please try again later.")
      action.data?.callback?.failure?.(e);
    }
  }
}

export function* sendOtpCustomertNumberEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosPost(`otp/send/customer?userName=9363334342&messageId=1`, action.data?.payload));
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Otp saved successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* otpWatcherSaga() {
  yield takeLatest(types.CREATE_OTP, sendOtpToUserNumberEffectSaga);
  // yield takeLatest(types.CREATE_OTP, sendOtpCustomertNumberEffectSaga);
}
